import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import { capitalize, get } from 'lodash';
import Carousel from 'nuka-carousel';
import ReactGA from 'react-ga';

import dems from './D.svg';
import repubs from './R.svg';
import independent from './I.svg';
import tweet from './tweet.svg';
import email from './email.svg';
import phone from './phone.svg';
import selected from './selectedCarousel.svg';
import unselected from './notSelectedCarousel.svg';
import arrowLeft from './arrowLeft.svg';
import arrowRight from './arrowRight.svg';


const parties = {
  D: { party: 'Democrat', img: dems },
  R: { party: 'Republican', img: repubs },
  I: { party: 'Independent', img: independent }
};


class Reps extends Component {
  constructor(props) {
    super(props);
  }

  handleAfterSlide = (currentSlideIndex) => {
    this.props.setIndex(currentSlideIndex);
  }

  handleSocialClick = (appId, network, id) => {
    ReactGA.event({
      category: 'Bespoke Contact Congress',
      action: 'click',
      label: network
    });
    browserHistory.push(`/${appId}/${network}/${id}`);
  }

  render() {
    const props = this.props;
    const appId = this.props.params.appId;
    const lowRepsClass = (props.reps.length < 2)? 'lowReps' : '';

    return (
      <div className="carouselWrapper">
        <Carousel
          className={lowRepsClass}
          afterSlide={this.handleAfterSlide}
          slideIndex={props.index}
          slidesToShow={props.slidesClip}
          slidesToScroll={props.slidesClip}
          cellSpacing={10}
          decorators={Decorators}>
          {props.reps.map((rep) => {

            let district = (rep.district)? (<span className="repDistrict">District<br/>{rep.district}</span>) : null;
            let party = get(parties, rep.party).img;
            let partyName = get(parties, rep.party).party;
            let twitterNotProvided = (!rep.twitter_id)? 'notProvided' : '';
            let emailNotProvided = (!rep.oc_email)? 'notProvided' : '';
            let phoneNotProvided = (!rep.phone)? 'notProvided' : '';

            return (
              <div className="Rep" key={rep.bioguide_id}>
                {district}
                <img className="repParty" src={party} alt={`${partyName} Party`} />
                <p className="repName">{`${rep.first_name} ${rep.last_name}`}</p>
                <p className="repChamber">{capitalize(rep.chamber)}</p>
                <div className="shareButtons">
                  <a className={`shareButton ${twitterNotProvided}`} onClick={() => twitterNotProvided? null : this.handleSocialClick(appId, 'tweet', rep.bioguide_id)}>
                    <img src={tweet} alt={`Tweet representative ${rep.first_name} ${rep.last_name}`} />
                    <span>tweet</span>
                  </a>
                  <a className={`shareButton ${emailNotProvided}`} onClick={() => emailNotProvided? null : this.handleSocialClick(appId, 'email', rep.bioguide_id)}>
                    <img src={email} alt={`Email representative ${rep.first_name} ${rep.last_name}`} />
                    <span>email</span>
                  </a>
                  <a className={`shareButton ${phoneNotProvided}`} onClick={() => phoneNotProvided? null : this.handleSocialClick(appId, 'call', rep.bioguide_id)}>
                    <img src={phone} alt={`Phone representative ${rep.first_name} ${rep.last_name}`} />
                    <span>call</span>
                  </a>
                </div>
              </div>
              );
          })}
        </Carousel>
      </div>
    );
  }
};

export default Reps;

var Decorators = [{
    component: (props) => {
      let opacity = props.currentSlide + props.slidesToScroll >= props.slideCount;
      let styles = {
        border: 0,
        background: 'transparent',
        cursor: 'pointer',
        opacity: opacity? 1 : .5,
        outline: 0
      };
      return (<button style={styles} onClick={props.previousSlide}><img src={arrowLeft} /></button>);
    },
    position: 'CenterLeft',
    style: { left: -40  }
  },
  {
    component: (props) => {
      let opacity = props.currentSlide + props.slidesToScroll >= props.slideCount;
      let styles = {
        border: 0,
        background: 'transparent',
        cursor: 'pointer',
        opacity: opacity? .5 : 1,
        outline: 0
      };
      return (<button style={styles} onClick={props.nextSlide}><img src={arrowRight} /></button>);
    },
    position: 'CenterRight',
    style: { right: -40  }
  },
  {
    component: React.createClass({
      displayName: "component",
      render: function() {
        var e = this,
            t = this.getIndexes(e.props.slideCount, e.props.slidesToScroll),
            selectionLogic = (e.props.slidesToScroll > 1)? doubleSlideIndex : singleSlideIndex;

        return React.createElement("ul", {
          style: e.getListStyles()
        }, t.map(function(t) {
          return React.createElement("li", {
            style: e.getListItemStyles(),
            key: t
          }, (<img
            style={e.getButtonStyles()}
            src={e.getButtonSource(selectionLogic(t, e.props.currentSlide))}
            onClick={() => {
              ReactGA.event({
                category: 'Bespoke Contact Congress',
                action: 'click',
                label: 'dotnav'
              });
              e.props.goToSlide.bind(null, t)();
            }} />))
        }))
      },
      getIndexes: function(e, t) {
        for (var n = [], r = 0; e > r; r += t)
        n.push(r);
        return n
      },
      getListStyles: function() {
        return {
          position: "relative",
          margin: 0,
          top: -10,
          padding: 0
        }
      },
      getListItemStyles: function() {
        return {
          listStyleType: "none",
          display: "inline"
        }
      },
      getButtonSource: function(e) {
        return e ? selected : unselected;
      },
      getButtonStyles: function() {
        return {
          border: 0,
          background: "transparent",
          color: "#c0392b",
          cursor: "pointer",
          padding: 5,
          lineHeight: "9px",
          outline: 0,
          fontSize: 18,
        }
      }
    }),
    position: "BottomCenter",
    style: {
      bottom: "-40px"
    }
  }
];

function doubleSlideIndex(t, currentSlide) {
  return currentSlide === t || Math.round(currentSlide/t) === 1;
}

function singleSlideIndex (t, currentSlide) {
  return currentSlide === t;
}



// WEBPACK FOOTER //
// ./src/Reps.js